// extracted by mini-css-extract-plugin
module.exports = {"header--button-wrapper":"HeaderButtonsGroupV2_header--button-wrapper__2e7zy","active":"HeaderButtonsGroupV2_active__2hiAY"};